import React, { useState, useEffect } from 'react';
import { Container, Paper, Typography, Box, LinearProgress, Grid } from '@mui/material';
import LocalFireDepartmentIcon from '@mui/icons-material/LocalFireDepartment';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import TimelineIcon from '@mui/icons-material/Timeline';

function Streaks() {
  const [streakData, setStreakData] = useState({
    currentStreak: 5,
    longestStreak: 10,
    totalWordsLearned: 50,
    dailyGoal: 10,
    wordsLearnedToday: 7,
    lastActiveDate: new Date().toLocaleDateString()
  });

  const calculateProgress = () => {
    return (streakData.wordsLearnedToday / streakData.dailyGoal) * 100;
  };

  return (
    <Container maxWidth="md" sx={{ mt: 4 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h4" gutterBottom align="center">
          Your Learning Progress
        </Typography>

        <Grid container spacing={4} sx={{ mt: 2 }}>
          {/* Current Streak */}
          <Grid item xs={12} md={4}>
            <Paper elevation={2} sx={{ p: 3, textAlign: 'center' }}>
              <LocalFireDepartmentIcon sx={{ fontSize: 40, color: 'orange' }} />
              <Typography variant="h6" gutterBottom>
                Current Streak
              </Typography>
              <Typography variant="h3" color="primary">
                {streakData.currentStreak} days
              </Typography>
            </Paper>
          </Grid>

          {/* Longest Streak */}
          <Grid item xs={12} md={4}>
            <Paper elevation={2} sx={{ p: 3, textAlign: 'center' }}>
              <EmojiEventsIcon sx={{ fontSize: 40, color: 'gold' }} />
              <Typography variant="h6" gutterBottom>
                Longest Streak
              </Typography>
              <Typography variant="h3" color="primary">
                {streakData.longestStreak} days
              </Typography>
            </Paper>
          </Grid>

          {/* Total Words */}
          <Grid item xs={12} md={4}>
            <Paper elevation={2} sx={{ p: 3, textAlign: 'center' }}>
              <TimelineIcon sx={{ fontSize: 40, color: 'green' }} />
              <Typography variant="h6" gutterBottom>
                Total Words Learned
              </Typography>
              <Typography variant="h3" color="primary">
                {streakData.totalWordsLearned}
              </Typography>
            </Paper>
          </Grid>
        </Grid>

        {/* Daily Progress */}
        <Box sx={{ mt: 4 }}>
          <Typography variant="h6" gutterBottom>
            Today's Progress
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
            <Typography variant="body1" sx={{ mr: 2 }}>
              {streakData.wordsLearnedToday} / {streakData.dailyGoal} words
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {calculateProgress().toFixed(0)}%
            </Typography>
          </Box>
          <LinearProgress
            variant="determinate"
            value={calculateProgress()}
            sx={{ height: 10, borderRadius: 5 }}
          />
        </Box>

        {/* Last Active */}
        <Box sx={{ mt: 4, textAlign: 'center' }}>
          <Typography variant="body2" color="text.secondary">
            Last active: {streakData.lastActiveDate}
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
}

export default Streaks; 